import type { ConfigRouteParamsRequest } from '@pba/utils';
import type { AxiosResponse } from 'axios';
import { getApiAxiosInstance } from '#client';
import type { CommunityDetailDataObject } from '#models/services';
import { routes } from '../routes';

type GetCommunityPathParams = {
  id: string;
};

type GetCommunityQueryParams = {
  invitation_token?: string;
};

export const getCommunity = async ({
  config: { params },
  routeParams: { id },
}: ConfigRouteParamsRequest<GetCommunityQueryParams, GetCommunityPathParams>) =>
  getApiAxiosInstance().get<CommunityDetailDataObject, AxiosResponse<CommunityDetailDataObject>>(
    routes.community.get(id),
    { params },
  );
